import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-transaction-form',
  templateUrl: './general-transaction-form.component.html',
  styleUrls: ['./general-transaction-form.component.css']
})
export class GeneralTransactionFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
